import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { ReportCardLayout } from '../../../models/ReportCardLayout';

@Component({
    selector: 'app-layout-switcher',
    templateUrl: './layout-switcher.component.html',
    styleUrls: ['./layout-switcher.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutSwitcherComponent {
  @Input() value: ReportCardLayout;
  @Output() setCardLayout = new EventEmitter<ReportCardLayout>();
}
